import React, { useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { Button, FormFieldSet, showToast } from "..";
import useDropdownData from "../../hooks/useDropdownData";

const AttachmentSection = ({
  attachments,
  onChange,
  getAttachmentError,
  showNameField = false,
  showCommentsField = false,
  showDocumentStatusField = false,
  showExpiryDateField = false,
  showDocumentTypeField = false,
  maxAttachments = 5,
}) => {
  const containerRef = useRef(null);
  const handleAddAttachment = () => {
    if (attachments.length >= maxAttachments) {
      showToast(
        `You can add a maximum of ${maxAttachments} attachments.`,
        "warning",
      );
      return;
    }

    onChange([
      ...attachments,
      {
        id: uuidv4(),
        attachmentName: "",
        attachmentComments: "",
        documentStatus: "",
        documentType: "",
        expiryDate: "",
        chooseFiles: [],
      },
    ]);
  };

  const handleRemoveAttachment = (id) => {
    if (attachments.length > 1) {
      onChange(attachments.filter((item) => item.id !== id));
    }
  };

  const handleAttachmentChange = (id, field, value) => {
    onChange(
      attachments.map((item) =>
        item.id === id ? { ...item, [field]: value } : item,
      ),
    );
  };

  // Helper function to check if any field has an error
  const hasError = (index) => {
    return (
      (showNameField && getAttachmentError(index, "attachmentName")) ||
      (showCommentsField && getAttachmentError(index, "attachmentComments")) ||
      (showDocumentStatusField &&
        getAttachmentError(index, "documentStatus")) ||
      (showDocumentTypeField && getAttachmentError(index, "documentType")) ||
      (showExpiryDateField && getAttachmentError(index, "expiryDate")) ||
      getAttachmentError(index, "chooseFiles")
    );
  };

  ///////////////////////////////////////////////////
  ///// Get select data form server
  ///////////////////////////////////////////////////
  const {
    data: documentTypesOptions,
    searchValue: documentTypesSearch,
    handleSearch: handleDocumentTypesSearch,
    resetSearch: resetDocumentTypesSearch,
    handleScroll: handleDocumentTypesScroll,
  } = useDropdownData("documentTypes");
  ///////////////////////////////////////////////////
  ///// Get select data form server end
  ///////////////////////////////////////////////////

  return (
    <>
      {attachments.map((attachment, index) => (
        <div key={attachment.id} className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-[repeat(5,1fr)_40px] gap-3 top-5">
          {showNameField && (
            <div className="flex-1">
              <FormFieldSet
                type="text"
                title=""
                placeholder="Attachment Name"
                value={attachment.attachmentName}
                onChange={(value) =>
                  handleAttachmentChange(attachment.id, "attachmentName", value)
                }
                error={getAttachmentError(index, "attachmentName")}
              />
            </div>
          )}
          {showCommentsField && (
            <div className="flex-1">
              <FormFieldSet
                type="text"
                title=""
                placeholder="Attachment Comments"
                value={attachment.attachmentComments}
                onChange={(value) =>
                  handleAttachmentChange(
                    attachment.id,
                    "attachmentComments",
                    value,
                  )
                }
                error={getAttachmentError(index, "attachmentComments")}
              />
            </div>
          )}
          {showDocumentTypeField && (
            <div className="flex-1">
              {/* <FormFieldSet
                type="select"
                title=""
                placeholder="Document Type"
                value={attachment.documentType}
                onChange={(value) =>
                  handleAttachmentChange(attachment.id, "documentType", value)
                }
                error={getAttachmentError(index, "documentType")}
                options={[
                  { label: "Document 1", value: 1 },
                  { label: "Document 2", value: 2 },
                ]}
              /> */}
              <FormFieldSet
                type="select"
                title=""
                placeholder="Select Document Type"
                keyname={"documentTypes"}
                options={documentTypesOptions}
                value={attachment.documentType}
                onChange={(value) =>
                  handleAttachmentChange(attachment.id, "documentType", value)
                }
                error={getAttachmentError(index, "documentType")}
                showSearch
                searchValue={documentTypesSearch}
                onSearch={handleDocumentTypesSearch}
                onClose={resetDocumentTypesSearch}
                showButton
                alertName={"addDocumentType"}
                icon={"add"}
                handleScroll={() => handleDocumentTypesScroll(containerRef)}
                refData={containerRef}
                //required
              />
            </div>
          )}
          {showDocumentStatusField && (
            <div className="min-w-[150px]">
              <FormFieldSet
                type="select"
                title=""
                placeholder="Status"
                value={attachment.documentStatus}
                onChange={(value) =>
                  handleAttachmentChange(attachment.id, "documentStatus", value)
                }
                error={getAttachmentError(index, "documentStatus")}
                options={[
                  { label: "Active", value: 1 },
                  { label: "Inactive", value: 2 },
                ]}
              />
            </div>
          )}
          {showExpiryDateField && (
            <div className="flex-1">
              <FormFieldSet
                type="datepicker"
                title=""
                placeholder="Select Expiry Date"
                value={attachment.expiryDate}
                onChange={(value) =>
                  handleAttachmentChange(attachment.id, "expiryDate", value)
                }
                error={getAttachmentError(index, "expiryDate")}
                showDropdown={false}
              />
            </div>
          )}
          <div
            className={`flex-1 ${
              !showNameField &&
              !showCommentsField &&
              !showDocumentStatusField &&
              !showExpiryDateField
                ? "flex-grow"
                : ""
            } overflow-hidden`}
          >
            <FormFieldSet
              type="file"
              title=""
              placeholder="Choose Files"
              value={attachment.chooseFiles}
              multiple
              onChange={(value) =>
                handleAttachmentChange(attachment.id, "chooseFiles", value)
              }
              error={getAttachmentError(index, "chooseFiles")}
            />
          </div>
          <div
            className={`flex items-center gap-2 mt-5  ${
              hasError(index) ? "mb-6" : ""
            }`}
          >
            <Button
              type="icon"
              icon="add"
              size="xs"
              color="black"
              onClick={handleAddAttachment}
            />
            <Button
              type="icon"
              icon="remove"
              size="xs"
              color="danger"
              onClick={() => handleRemoveAttachment(attachment.id)}
              disabled={attachments.length <= 1}
            />
          </div>
        </div>
      ))}
    </>
  );
};

export default AttachmentSection;
